<template>
  <default>
    <div v-if="product" class="mx-auto p-6 space-y-8 dark:bg-gray-900 min-h-screen">

      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Produkt č. {{ product.id }}</h1>

      <!-- Základní informace -->
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 space-y-2">
        <p class="text-gray-800 dark:text-gray-200"><strong>Název:</strong> {{ product.name }}</p>
        <p v-if="product.code" class="text-gray-800 dark:text-gray-200"><strong>Kód:</strong> {{ product.code }}</p>
        <p v-if="product.unit" class="text-gray-800 dark:text-gray-200"><strong>Jednotka:</strong> {{ product.unit }}</p>
        <p v-if="product.price !== undefined" class="text-gray-800 dark:text-gray-200">
          <strong>Cena:</strong> {{ product.price }} Kč s DPH
        </p>
        <p v-if="product.priceWithoutVAT !== undefined" class="text-gray-800 dark:text-gray-200">
          <strong>Cena bez DPH:</strong> {{ product.priceWithoutVAT }} Kč
        </p>
        <p v-if="product.vatRate !== undefined" class="text-gray-800 dark:text-gray-200">
          <strong>DPH:</strong> {{ product.vatRate }} %
        </p>
      </div>

      <!-- Tagy -->
      <div v-if="product.tags?.length" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <h2 class="font-semibold text-lg mb-2 text-gray-800 dark:text-gray-100">Štítky</h2>
        <div class="flex flex-wrap gap-2">
          <span
              v-for="tag in product.tags"
              :key="tag"
              class="px-2 py-1 text-sm rounded bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
          >
            {{ tag }}
          </span>
        </div>
      </div>

      <!-- Custom -->
      <div v-if="product.custom" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <h2 class="font-semibold text-lg mb-2 text-gray-800 dark:text-gray-100">Custom data</h2>
        <RecursiveJson :data="product.custom" />
      </div>

      <LogsTable :entity-id="product.id" class="mt-4" />
    </div>

    <!-- Loading skeleton -->
    <div v-else class="mx-auto p-6 space-y-8 dark:bg-gray-900 min-h-screen animate-pulse">
      <div class="h-6 w-48 bg-gray-300 dark:bg-gray-700 rounded"></div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 space-y-2">
        <div class="h-4 w-1/2 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div class="h-3 w-1/3 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div class="h-3 w-2/3 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div class="h-3 w-1/4 bg-gray-300 dark:bg-gray-700 rounded"></div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 space-y-2">
        <div class="h-4 w-1/4 bg-gray-300 dark:bg-gray-700 rounded mb-2"></div>
        <div class="flex gap-2">
          <div class="h-3 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div class="h-3 w-12 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 space-y-2">
        <div class="h-4 w-1/4 bg-gray-300 dark:bg-gray-700 rounded mb-2"></div>
        <div class="h-3 w-full bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div class="h-3 w-3/4 bg-gray-300 dark:bg-gray-700 rounded"></div>
      </div>
    </div>
  </default>
</template>

<script lang="ts">

import Default from "@/layouts/admin/default.vue";
import LogsTable from "@/components/logsTable/logsTable.vue";
import RecursiveJson from "@/components/RecursiveJson.vue";
import {ResponseEntityOrder, ResponseEntityProduct} from "@haxo-cz/orders-ts-client";
import {useAppStore} from "@/stores/appStore";

export default {
  name: "ProductDetailView",
  components: {LogsTable, RecursiveJson, Default},
  data() {
    return {
      productId: this.$route.params.productId,
      product: null as ResponseEntityProduct | null,
      appStore: useAppStore()
    }
  },
  methods: {
    async findProduct() {
      await this.$productsApi.findProduct(
          this.appStore.selectedProject.spaceId,
          this.appStore.selectedProject._id,
          this.productId
      ).then(response => {
        this.product = response.data;
      }).catch(e => {
        console.log(e)
      });
    },
    formatDate(date: string | Date): string {
      return new Date(date).toLocaleString('cs-CZ')
    }
  },
  mounted() {
    this.findProduct();
  }
}
</script>